(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('YieldCurvePointDialogController', YieldCurvePointDialogController);

    YieldCurvePointDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'YieldCurvePoint', 'YieldCurveResults'];

    function YieldCurvePointDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, YieldCurvePoint, YieldCurveResults) {
        var vm = this;

        vm.yieldCurvePoint = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.yieldcurveresults = YieldCurveResults.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.yieldCurvePoint.id !== null) {
                YieldCurvePoint.update(vm.yieldCurvePoint, onSaveSuccess, onSaveError);
            } else {
                YieldCurvePoint.save(vm.yieldCurvePoint, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:yieldCurvePointUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
